import { AUTO_STYLE, animate, state, style, transition, trigger } from '@angular/animations';
import { Component, output, input, inject, effect, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuCollapseService } from '../../dynamic-header/services/menu-collapse.service';
import { MenuItems } from '../../dynamic-header/category/header-data';
import { HeaderLayout } from '../../dynamic-header/dynamic-header.component';

export const DEFAULT_DURATION = 300;
@Component({
  selector: 'app-static-sub-menu',
  templateUrl: './static-sub-menu.component.html',
  styleUrls: ['./static-sub-menu.component.scss'],
  standalone: true,
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ],
  imports: [CommonModule]
})
export class StaticSubMenuComponent {
  private menuCollapseService = inject(MenuCollapseService);

  readonly menuItem = input.required<MenuItems>();
  readonly menuCollapseIcon = input<string>("");
  readonly collapsed = input<boolean>(false);
  readonly headerLayout = input<string>('default');

  // Computed property to check if layout is headerLayout12
  readonly isLayout12 = computed(() => this.headerLayout() === HeaderLayout.headerLayout12);
  
  HeaderLayout = HeaderLayout; // Exposed enum to template

  // Update output to use Angular 20 output() function
  hideMenu$ = output<any>();

  constructor() {
    // Use effect to watch isDynamicMenu signal changes
    effect(() => {
      const isDynamic = this.menuCollapseService.isDynamicMenu();
      if (isDynamic) {
      }
    });
  }

  toggle() {
    this.menuCollapseService.setStaticMenu(true);
    this.menuCollapseService.setDynamicMenu(false);
    // Note: Since collapsed is now a readonly input, toggle logic needs to be handled by parent
  }

  expand() {
    // Note: Since collapsed is now a readonly input, this needs to be handled by parent
  }

  collapse() {
    // Note: Since collapsed is now a readonly input, this needs to be handled by parent
  }
}

